import i18n from "@/i18n.ts";
import { SelectItem } from "@skailer-com/uikit";

export enum ProbationPolicyUnitTypes {
  days = "days",
  months = "months",
}

export const getProbationPolicyUnitTypeItems = () => {
  return [
    {
      id: ProbationPolicyUnitTypes.days,
      title: i18n.t("common:days"),
    },
    {
      id: ProbationPolicyUnitTypes.months,
      title: i18n.t("common:months"),
    },
  ] as SelectItem[];
};

export interface ApiProbationPolicy {
  id: number;
  is_archived: boolean;
  title: string;
  amount: number;
  unit: ProbationPolicyUnitTypes;
}

export interface ApiProbationPolicyPayload {
  title: string;
  amount: number;
  unit: ProbationPolicyUnitTypes;
}
